import { render, staticRenderFns } from "./ModalLikes.vue?vue&type=template&id=24c4a1ce"
import script from "./ModalLikes.vue?vue&type=script&lang=js"
export * from "./ModalLikes.vue?vue&type=script&lang=js"
import style0 from "./ModalLikes.vue?vue&type=style&index=0&id=24c4a1ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports